import Vue from "vue";
import {
  Toast
} from 'vant';
import apis from "@/config/api.config.js"
import qs from "qs";

export default {
  name: "index",
  data() {
    return {
      show: false,
      hasRegisted: false,
      hasError:false,
    };
  },
  methods: {
    routerJump(path) {
      if (this.hasRegisted && !this.hasError) {
        this.$router.push(path);
      }
      else {
        Toast({
          message:"该功能需要注册才能查看",
          forbidClick:true,
        });
      }
    },

    toGlory() {
      if (this.hasRegisted) {
        this.$router.push("/glory");
      }
      else {
        Toast("该功能需要注册才能查看");
      }

    },
    toGame() {
      if ( !this.hasError) {
        if (this.hasRegisted ) {
          this.$router.push("/game");
        }
        else {
          // 注册
          this.$router.push('/regist')
        }
      }
      else{
        Toast({
          message:"网络请求失败，请稍后重试",
          forbidClick:true,
        });
      }

    },
    getUserNameExisted() {
      let env = localStorage.getItem('env');
      if (false && env != "app") {
        this.$router.push('/game');
      }
      else {
        const that = this;
        let toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '提交中',
        });
        let post_data = {
          // device: 'ssdsdfsdfsfsdfdsfggdda', //传device
          data: localStorage.getItem("luoohutoken"), //获取到device
        };
        that
          .axios({
            method: "post",
            // headers: { "Content-Type": "application/x-www-form-urlencoded" },
            // url: apis.getActivityList,
            url: apis.getUserNameExisted,
            // url: apis.getAppUserInfo,
            data: qs.stringify(post_data),
          })
          .then((res) => {
            console.log(res);

            Toast.clear();// 清除所有弹框
            res = res.data;

            if (res.code == 200) {
              // 注册
              that.hasRegisted = false;
            }
            else {
              // 答题
              that.hasRegisted = true;
            }
          })
          .catch((rej) => {
            console.log(rej);
            that.hasError = true;
            Toast("网络请求失败，请稍后重试");
          });
      }
    },
    showPopup() {
      this.show = true;
    },

  },

  created() {
    // console.log('created');
    const that = this;
    that.getUserNameExisted();

  },

};